import type { HighlightedQuoteSlice } from "~/api/prismic/types"
import CustomRichText from "~/components/CustomRichText"
import TailwindProseWrapper from "~/components/TailwindProseWrapper"

type Props = {
  slice: HighlightedQuoteSlice
}

const HighlightedQuote: React.FC<Props> = ({ slice }) => {
  const quote = slice.primary.quote_text

  return (
    <TailwindProseWrapper>
      <div className="max-w-screen-lg">
        <blockquote className="bg-gray-100 dark:bg-primary-700">
          <div className="py-px">
            <CustomRichText field={quote} />
          </div>
        </blockquote>
      </div>
    </TailwindProseWrapper>
  )
}

export default HighlightedQuote
